import React from "react";

export const ErrorModal = ({ message, onClose }) => {
  if (!message) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/40 p-4 backdrop-blur-sm">
      <div className="w-full max-w-md rounded-2xl border border-rose-200 bg-white p-5 shadow-2xl">
        <div className="mb-2 text-sm font-semibold uppercase tracking-[0.12em] text-rose-600">Notice</div>
        <div className="mb-5 text-sm leading-relaxed text-slate-700">{message}</div>
        <div className="flex justify-end">
          <button
            className="rounded-xl bg-rose-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-rose-700"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};
